import * as React from "react";
import PropTypes from "prop-types";

import { ItemRecommendationCarousel } from "@lululemon/recommenders";
import { LinkProvider } from "@lululemon/ui-library";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";

const GoesWellWithCarousel = ({
  fusionExperimentVariant,
  gwwRef,
  locale,
  productId,
  onResolved,
}) => {
  return (
    <LinkProvider component={LinkGenerator}>
      <div className="wrapper lll-grid-padding OneLinkTx" ref={gwwRef}>
        <ItemRecommendationCarousel
          analyticsAttributes={{
            "data-lulu-track": "pdp-supplemental-recommendation",
          }}
          analyticsId="recommendation:gww"
          fusionExperimentVariant={fusionExperimentVariant}
          heading="Goes well with"
          itemCount={8}
          itemId={productId}
          locale={locale}
          modelId="ProductModelXsellV1"
          onResolved={onResolved}
          showSwatches={false}
        />
      </div>
    </LinkProvider>
  );
};

GoesWellWithCarousel.propTypes = {
  fusionExperimentVariant: PropTypes.string,
  gwwRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  locale: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  onResolved: PropTypes.func.isRequired,
};

GoesWellWithCarousel.defaultProps = {
  fusionExperimentVariant: undefined,
};

export default GoesWellWithCarousel;
